export default __webpack_public_path__ + "static/button-label-do-f88db35d2e761452081a0fc8f3ee8134.png";